/* Cart drawer extras: cross-sell variant images and carousel arrows. Moved out of sections/cart-drawer.liquid
   so browsers cache it instead of downloading it inside every page. */
(function () {
  if (window.__canchaCartDrawerExtrasLoaded) return;
  window.__canchaCartDrawerExtrasLoaded = true;

  // Cross-sell variant image switcher - uses event delegation so works with dynamically loaded content
  document.addEventListener('change', function(e) {
    const select = e.target.closest('select.cross-sell-variant-select');
    if (!select) return;

    const option = select.options[select.selectedIndex];
    const imageUrl = option.getAttribute('data-image');
    const card = select.closest('.product-cross-sell');
    const imgContainer = card ? card.querySelector('.product-cross-sell__image') : null;
    const img = imgContainer ? imgContainer.querySelector('img') : null;

    if (imageUrl && img) {
      const newImg = new Image();
      newImg.onload = function() {
        img.src = imageUrl;
        img.removeAttribute('srcset');
        img.removeAttribute('sizes');
      };
      newImg.src = imageUrl;
    }
  });

  // No extra refresh after add to cart: the add request already returns the
  // freshly rendered drawer. (A forced reload 800ms later used to redraw the
  // drawer, and hide the kit carousel, just after it opened.)

  (function() {
    // Use event delegation for carousel navigation - handles dynamically loaded content
    document.addEventListener('click', function(e) {
      const prevBtn = e.target.closest('.cart-drawer__carousel-prev');
      const nextBtn = e.target.closest('.cart-drawer__carousel-next');

      if (!prevBtn && !nextBtn) return;

      e.preventDefault();
      e.stopPropagation();

      const section = (prevBtn || nextBtn).closest('.cart-drawer__cross-sell');
      if (!section) return;

      const carousel = section.querySelector('.cart-drawer__cross-sell-carousel');
      if (!carousel) return;

      const itemWidth = carousel.querySelector('.product-cross-sell')?.offsetWidth || 200;
      const scrollAmount = itemWidth + 16;

      if (prevBtn) {
        carousel.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
      } else {
        carousel.scrollBy({ left: scrollAmount, behavior: 'smooth' });
      }

      // Update button states after scroll completes
      setTimeout(() => updateCarouselButtons(section), 350);
    });

    function updateCarouselButtons(section) {
      const carousel = section.querySelector('.cart-drawer__cross-sell-carousel');
      const prevBtn = section.querySelector('.cart-drawer__carousel-prev');
      const nextBtn = section.querySelector('.cart-drawer__carousel-next');

      if (!carousel || !prevBtn || !nextBtn) return;

      const scrollLeft = carousel.scrollLeft;
      const maxScroll = carousel.scrollWidth - carousel.clientWidth;

      prevBtn.disabled = scrollLeft <= 5;
      nextBtn.disabled = scrollLeft >= maxScroll - 5;
    }

    // Initialize button states when content loads
    function initCarouselButtons() {
      document.querySelectorAll('.cart-drawer__cross-sell').forEach(section => {
        const carousel = section.querySelector('.cart-drawer__cross-sell-carousel');
        if (!carousel) return;

        // Set up scroll listener for button state updates
        if (!carousel.dataset.scrollListenerAdded) {
          carousel.dataset.scrollListenerAdded = 'true';
          carousel.addEventListener('scroll', () => updateCarouselButtons(section), { passive: true });
        }

        // Initial state
        updateCarouselButtons(section);
      });
    }

    // Watch for dynamically loaded content
    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (node.nodeType === 1) {
            if (node.classList?.contains('cart-drawer__cross-sell') ||
                node.querySelector?.('.cart-drawer__cross-sell')) {
              setTimeout(initCarouselButtons, 100);
              return;
            }
          }
        }
      }
    });

    // Watch only the cart drawer (it stays in the page; its contents are swapped on every cart change),
    // instead of every change anywhere on the page.
    const cartDrawer = document.getElementById('cart-drawer');
    if (cartDrawer) observer.observe(cartDrawer, { childList: true, subtree: true });

    // Initial setup
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initCarouselButtons);
    } else {
      initCarouselButtons();
    }

    // Prevent cross-sell flicker during cart refresh
    // Mark product-recommendations as loading before refresh, remove after
    document.addEventListener('cart:refresh', function() {
      const recs = document.querySelector('cart-drawer product-recommendations');
      if (recs) recs.classList.add('is-loading');
    });
    document.addEventListener('cart-drawer:refreshed', function() {
      // Wait for product-recommendations to finish loading
      setTimeout(function() {
        const recs = document.querySelector('cart-drawer product-recommendations');
        if (recs) recs.classList.remove('is-loading');
      }, 300);
    });
  })();
})();
